import en from "../__constants__/locales/en.json"
import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import no from "../__constants__/locales/no.json"
import pl from "../__constants__/locales/pl.json"
import uk from "../__constants__/locales/uk.json"

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    no: { translation: no },
    uk: { translation: uk },
    pl: { translation: pl },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
